export const groupMappings: {
  [key: string]: { group: string; states: string[] };
} = {
  Assam: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  'Arunanchal Pradesh': {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Manipur: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Mizoram: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Nagaland: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Tripura: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Meghalaya: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Sikkim: {
    group: 'Assam & North East',
    states: ['Assam', 'Arunanchal Pradesh', 'Manipur', 'Mizoram', 'Nagaland', 'Tripura', 'Meghalaya', 'Sikkim'],
  },
  Maharashtra: {
    group: 'Maharashtra + Goa',
    states: ['Maharashtra', 'Goa'],
  },
  Goa: {
    group: 'Maharashtra + Goa',
    states: ['Maharashtra', 'Goa'],
  },
  'NCT of Delhi': {
    group: 'Delhi/NCR',
    states: ['NCT of Delhi'],
  },
  'Jammu and Kashmir': {
    group: 'Jammu',
    states: ['Jammu and Kashmir', 'Himachal Pradesh'],
  },
  'Himachal Pradesh': {
    group: 'Jammu',
    states: ['Jammu and Kashmir', 'Himachal Pradesh'],
  },
  Odisha: {
    group: 'Orissa',
    states: ['Odisha'],
  },
  Uttarakhand: {
    group: 'Uttar Pradesh',
    states: ['Uttarakhand', 'Uttar Pradesh'],
  },
  'Uttar Pradesh': {
    group: 'Uttar Pradesh',
    states: ['Uttarakhand', 'Uttar Pradesh'],
  },
  Puducherry: {
    group: 'Tamil Nadu',
    states: ['Tamil Nadu', 'Puducherry'],
  },
  'Tamil Nadu': {
    group: 'Tamil Nadu',
    states: ['Tamil Nadu', 'Puducherry'],
  },
};

export const mapReplacements: { [key: string]: string[] } = {
  'Assam & North East': [
    'Assam',
    'Arunanchal Pradesh',
    'Manipur',
    'Mizoram',
    'Nagaland',
    'Tripura',
    'Meghalaya',
    'Sikkim',
  ],
  'Maharashtra + Goa': ['Maharashtra', 'Goa'],
  'Delhi/NCR': ['NCT of Delhi'],
  Jammu: ['Jammu and Kashmir', 'Himachal Pradesh'],
  Orissa: ['Odisha'],
  'Uttar Pradesh': ['Uttar Pradesh', 'Uttarakhand'],
  'Tamil Nadu': ['Tamil Nadu', 'Puducherry'],
};

export const allAvailableStates = [
  'Andaman and Nicobar',
  'Aksai Chin',
  'Balochistan',
  'Uttarakhand',
  'Jammu and Kashmir',
  'Punjab',
  'Rajasthan',
  'Gujarat',
  'Maharashtra',
  'Kerala',
  'Tamil Nadu',
  'West Bengal',
  'Assam',
  'Bihar',
  'Uttar Pradesh',
  'Madhya Pradesh',
  'Odisha',
  'Telangana',
  'Karnataka',
  'Chhattisgarh',
  'Jharkhand',
  'Andhra Pradesh',
  'Goa',
  'Manipur',
  'Mizoram',
  'Nagaland',
  'Tripura',
  'Meghalaya',
  'Sikkim',
  'Arunanchal Pradesh',
  'Haryana',
  'Puducherry',
  'Lakshadweep',
  'Himachal Pradesh',
  'NCT of Delhi',
];
